<template>
  <div class="bg-page-container">
    <!-- 页面头部 -->
    <div class="bg-page-header">
      <div class="header-title">
        <i class="el-icon-s-goods"></i>
        <span>产品管理</span>
      </div>
    </div>

    <!-- 查询和操作区域 -->
    <div class="bg-toolbar">
      <div class="toolbar-left">
        <queryc @change="change" class="query-component"></queryc>
      </div>
      <div class="toolbar-right">
        <el-upload
          class="upload-inline"
          action=""
          :on-change="handleChange"
          :auto-upload="false"
          :show-file-list="false"
          :file-list="fileList">
          <el-button slot="trigger" size="small" icon="el-icon-folder-opened">选取文件</el-button>
        </el-upload>
        <el-button size="small" type="success" icon="el-icon-upload" @click="uploadFile" :loading="uploadloading">上传</el-button>
        <el-button size="small" type="primary" icon="el-icon-download" @click="downloadFile" :loading="downloadloading">下载</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="bg-table-section">
      <el-table
        v-loading="loading"
        :data="productList"
        :height="tableHeight"
        class="bg-table"
        stripe>
        <el-table-column prop="productCode" label="产品编码" min-width="180" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="180" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="levelName" label="级别" width="100" align="center">
        </el-table-column>
        <el-table-column prop="unitName" label="单元" width="100" align="center">
        </el-table-column>
        <el-table-column prop="partName" label="部分" width="120" align="center">
        </el-table-column>
        <el-table-column prop="deleteFlag" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.deleteFlag === '生效' ? 'success' : 'info'" size="small" effect="plain">
              {{ scope.row.deleteFlag }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              class="text-danger"
              icon="el-icon-circle-close"
              @click="disableProduct(scope.$index, scope.row)">
              禁用
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="bg-pagination"
        background
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="currentChange"
        :total="totalCount"
        :page-sizes="[15, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <!-- 空状态 -->
    <bg-empty
      v-if="!loading && productList.length === 0"
      icon="el-icon-s-goods"
      description="暂无产品数据"
      hint="请使用查询条件筛选产品或使用上传功能导入数据">
    </bg-empty>

    <!-- 新增/编辑对话框 -->
    <el-dialog title="产品信息" :visible.sync="dialogVisible" width="500px" class="bg-dialog" :before-close="handleClose">
      <el-form ref="form" :model="product" label-width="80px" size="small">
        <el-form-item label="产品编码">
          <el-input v-model="product.productCode" placeholder="请输入产品编码"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="product.productName" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="单元">
          <el-input v-model="product.unitName" placeholder="请输入单元信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/utils/api'
import query from '@/components/common/cascadeQeury'
import BgEmpty from '@/components/common/BgEmpty'

export default {
  name: 'Product',
  components: {
    'queryc': query,
    BgEmpty
  },
  data () {
    return {
      fileList: [],
      currentFile: '',
      loading: false,
      uploadloading: false,
      downloadloading: false,
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      productList: [],
      tableHeight: 0,
      dialogVisible: false,
      product: {
        productCode: '',
        productName: '',
        levelName: '',
        unitName: '',
        partName: '',
        sourceUrl: '',
        deleteFlag: ''
      }
    }
  },
  created () {
    this.tableHeight = (window.innerHeight - 195)
    this.query()
  },
  mounted () {

  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    downloadFile () {
      this.downloadloading = true
      this.$axios.post(api.downloadProduct, { para: 1 }, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; application/octet-stream' })
          const elink = document.createElement('a')
          elink.download = '产品列表.xlsx'
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
          this.downloadloading = false
        }).catch((error) => {
          this.downloadloading = false
          this.$message({
            message: error
          })
        })
    },
    uploadFile () {
      var file = this.currentFile
      if (file === '') {
        this.$message({ message: '请先选择上传文件', type: 'warning' })
        return
      }
      var formData = new FormData()
      formData.append('file', file.raw)
      this.uploadloading = true
      var _this = this
      return this.$axios.post(api.uploadProduct, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          if (res.data.result === 'SUCCESS') {
            _this.uploadloading = false
            _this.$message({ message: file.name + '文件上传成功', type: 'success' })
            return true
          } else {
            _this.uploadloading = false
            _this.$message({ message: res.data.result, type: 'error' })
            return false
          }
        })
        .catch(function (error) {
          _this.$message({ message: error.message, type: 'error' })
          _this.uploadloading = false
          return false
        })
    },
    handleChange (file, fileList) {
      this.currentFile = file
    },
    onSubmit () {
      this.loading = true
      this.user.roles = this.selectUsers
      this.$axios.post(api.createUser, this.user)
        .then(res => {
          this.userList = res.data.result
          this.getUsers()
          this.loading = false
        })
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    disableProduct (id, row) {
      let param = new URLSearchParams()
      param.append('id', row.id)
      this.$axios.post(api.disableProduct, param)
        .then(res => {
          this.userList = res.data.result
          this.getUsers()
        })
    },
    currentChange (current) {
      this.pageIndex = current
      this.query()
    },
    change: function (query) {
      this.pageIndex = 1
      this.selectSeries = query.selectSeries
      this.selectLevels = query.selectLevels
      this.selectUnits = query.selectUnits
      this.query()
    },
    query () {
      this.loading = true
      this.$axios.post(api.getProductParts, { PageIndex: this.pageIndex, Series: this.selectSeries, Level: this.selectLevels, ProductUnit: this.selectUnits, PageSize: this.pageSize })
        .then(res => {
          this.productList = res.data.result.items
          this.totalCount = res.data.result.totalCount
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.bg-page-container {
  @include page-container;
}

.bg-page-header {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);

  .header-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-lg;
    font-weight: 600;
    color: var(--text-primary);

    i {
      font-size: $font-size-xl;
      color: $primary-color;
    }
  }
}

.bg-toolbar {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);
  flex-wrap: wrap;
  gap: $spacing-md;

  .toolbar-left {
    flex: 1;
    min-width: 300px;
  }

  .toolbar-right {
    display: flex;
    gap: $spacing-sm;
    align-items: center;
  }

  .upload-inline {
    display: inline-block;
  }
}

.bg-table-section {
  @include table-section;

  .bg-table {
    border-radius: $border-radius-sm;
    overflow: hidden;

    .el-table__header {
      background: var(--gradient-header);

      th {
        font-weight: 600;
        color: var(--text-primary);
        background: transparent;
      }
    }
  }

  .text-danger {
    color: $danger-color;

    &:hover {
      color: $danger-dark;
    }
  }
}

.bg-pagination {
  margin-top: $spacing-lg;
  text-align: center;
}

// 响应式适配
@media (max-width: $screen-md) {
  .bg-toolbar {
    flex-direction: column;
    align-items: stretch;

    .toolbar-left {
      min-width: auto;
    }

    .toolbar-right {
      justify-content: flex-start;
    }
  }
}

@media (max-width: $screen-sm) {
  .bg-page-header {
    flex-direction: column;
    gap: $spacing-md;
    align-items: flex-start;
  }

  .toolbar-right {
    flex-wrap: wrap;

    .el-button {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/Products.vue